<template>
  <v-menu
    v-if="debugStore.isDebugMode"
    offset-y
    :close-on-content-click="false"
  >
    <template #activator="{ props }">
      <v-btn
        icon
        v-bind="props"
        :color="debugStore.isEnabled ? 'success' : 'error'"
        size="small"
        class="mx-1"
      >
        <v-icon>{{
          debugStore.isEnabled ? "mdi-wifi" : "mdi-wifi-off"
        }}</v-icon>
        <v-tooltip activator="parent" location="bottom">
          ActionCable: {{ debugStore.isEnabled ? "ON" : "OFF" }} <br />{{
            debugStore.connectionCount
          }}
          connections
        </v-tooltip>
      </v-btn>
    </template>

    <v-card min-width="300" @click.stop>
      <v-card-title class="d-flex align-center">
        <v-icon class="mr-2">mdi-wifi-settings</v-icon>
        ActionCable Debug
      </v-card-title>

      <v-card-text @click.stop>
        <!-- Toggle - with click.stop to prevent menu closing -->
        <div class="d-flex align-center mb-4" @click.stop>
          <v-switch
            :model-value="debugStore.enabled"
            :label="debugStore.isEnabled ? 'Enabled' : 'Disabled'"
            color="success"
            hide-details
            @update:model-value="handleToggle"
            @click.stop
          ></v-switch>
          <v-spacer></v-spacer>
          <v-chip
            :color="debugStore.isEnabled ? 'success' : 'error'"
            size="small"
          >
            {{ debugStore.connectionCount }} connections
          </v-chip>
        </div>

        <!-- Connections Status -->
        <div v-if="debugStore.activeConnections.length > 0">
          <h4 class="text-subtitle-2 mb-2">Active Connections:</h4>
          <v-list dense>
            <v-list-item
              v-for="conn in debugStore.activeConnections"
              :key="conn.name"
              class="px-0"
            >
              <template #prepend>
                <v-icon
                  :color="conn.connected ? 'success' : 'error'"
                  size="small"
                >
                  {{ conn.connected ? "mdi-check-circle" : "mdi-close-circle" }}
                </v-icon>
              </template>
              <v-list-item-title class="text-caption">
                {{ conn.channel }}
              </v-list-item-title>
              <v-list-item-subtitle class="text-caption">
                {{ conn.name }}
              </v-list-item-subtitle>
            </v-list-item>
          </v-list>
        </div>

        <!-- Recent Messages -->
        <div v-if="debugStore.recentMessages.length > 0" class="mt-4">
          <h4 class="text-subtitle-2 mb-2">Recent Messages:</h4>
          <v-card variant="outlined" max-height="200" style="overflow-y: auto">
            <v-list dense>
              <v-list-item
                v-for="msg in debugStore.recentMessages"
                :key="msg.id"
                class="px-2"
              >
                <v-list-item-title class="text-caption">
                  {{ msg.channel }}
                </v-list-item-title>
                <v-list-item-subtitle class="text-caption">
                  {{ formatTime(msg.timestamp) }} -
                  {{ msg.message.slice(0, 50) }}...
                </v-list-item-subtitle>
              </v-list-item>
            </v-list>
          </v-card>
        </div>

        <!-- No connections message -->
        <div
          v-if="debugStore.activeConnections.length === 0"
          class="text-center py-4"
        >
          <v-icon size="48" color="grey-lighten-1" class="mb-2"
            >mdi-wifi-off</v-icon
          >
          <p class="text-body-2 text-medium-emphasis">No active connections</p>
        </div>
      </v-card-text>

      <v-card-actions @click.stop>
        <v-btn
          size="small"
          prepend-icon="mdi-delete"
          variant="outlined"
          @click.stop="debugStore.clearHistory"
        >
          Clear History
        </v-btn>
        <v-spacer></v-spacer>
        <v-btn
          size="small"
          color="error"
          prepend-icon="mdi-wifi-off"
          variant="outlined"
          @click.stop="debugStore.disconnectAll"
        >
          Disconnect All
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-menu>
</template>

<script setup>
import { useActionCableDebugStore } from "@/stores/actionCableDebugStore";

const debugStore = useActionCableDebugStore();

const handleToggle = () => {
  console.log(
    `🔧 ActionCable Debug: Toggle called, current state: ${debugStore.enabled}`,
  );
  debugStore.toggle();
  console.log(`🔧 ActionCable Debug: New state: ${debugStore.enabled}`);
};

const formatTime = (timestamp) => {
  return new Date(timestamp).toLocaleTimeString();
};
</script>
